import { environment } from '@app/env';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { AlertService } from './api/alert.service';
import { RoleValues } from '@api/types';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { Store } from '@ngrx/store';
import * as fromApp from './store';
import { filter, tap, take } from 'rxjs/operators';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app',
  styleUrls: ['./app.component.scss'],
  template: `
    <div class="alert-global__container">
      <alert
        *ngFor="let alert of alerts; let i = index"
        [dismissOnTimeout]="alert.timeout"
        (onClosed)="removeAlert($event, i)"
        [type]="alert.type"
        dismissable="false"
        class="alert--global"
      >
        <span [innerHtml]="alert.message"></span>
      </alert>
    </div>
    <div class="app-wrapper" #appWrapper data-iframe-height>
      <app-header *ngIf="showLoggedInComponents"></app-header>
      <router-outlet></router-outlet>
      <app-footer-desktop class="hidden-sm-down" *ngIf="showLoggedInComponents"></app-footer-desktop>
      <div class="app-tabs-spacer hidden-md-up"></div>
    </div>
    <app-footer-touch class="hidden-md-up" *ngIf="showLoggedInComponents"></app-footer-touch>
    <app-popovers></app-popovers>
    <!-- hide when logged out -->
    <app-tabs class="hidden-md-up" *ngIf="showLoggedInComponents"></app-tabs>
  `,
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('appWrapper', { static: false })
  appWrapper: any;
  public alerts: any[];
  public showLoggedInComponents: boolean;

  private routerEvents$: Subscription;
  private profile$: Subscription;
  private alerts$: Subscription;

  constructor(
    private store: Store<any>,
    private router: Router,
    private alertService: AlertService,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics
  ) {
    angulartics2GoogleAnalytics.startTracking();
  }

  ngOnInit() {
    this.getRouterEvents();
    this.getAlerts();
    this.getProfile();
  }

  getRouterEvents() {
    this.routerEvents$ = this.router.events
      .pipe(
        tap((event: Event) => {
          if (event instanceof NavigationEnd && window['parentIFrame']) {
            window['parentIFrame'].sendMessage({
              message: 'routeChange',
              route: event.urlAfterRedirects,
            });
          }
        }),
        tap((event: Event) => this.handleNavigationEnd(event))
      )
      .subscribe();
  }

  handleNavigationEnd(event) {
    if (event instanceof NavigationEnd) {
      if (
        event.urlAfterRedirects.indexOf('profile') !== -1 ||
        event.urlAfterRedirects.indexOf('recipes') !== -1 ||
        event.urlAfterRedirects.indexOf('shoplist') !== -1 ||
        event.urlAfterRedirects.indexOf('shopping-list') !== -1 ||
        event.urlAfterRedirects.indexOf('payment') !== -1 ||
        event.urlAfterRedirects.indexOf('recommendations') !== -1 ||
        event.urlAfterRedirects.indexOf('meals') !== -1
      ) {
        this.showLoggedInComponents = true;
      } else {
        this.showLoggedInComponents = false;
      }
      // scroll to the top of the page after every route change
      if (this.appWrapper) {
        this.appWrapper.nativeElement.scrollTop = 0;
      }
    }
  }

  getAlerts() {
    this.alerts$ = this.alertService
      .getAlerts()
      .pipe(
        filter((res) => !!res),
        tap((res) => (this.alerts = res))
      )
      .subscribe();
  }

  getProfile() {
    this.profile$ = this.store
      .select(fromApp.selectUser)
      .pipe(
        filter((user) => !!user),
        filter((user) => user.role === RoleValues.NORMAL),
        tap((user) => {
          // Also set userId for GA
          this.angulartics2GoogleAnalytics.setUsername(user.userId.toString());
          if (window['Bugsnag']) {
            window['Bugsnag'].user = {
              id: user.userId,
            };
          }
        }, take(1))
      )
      .subscribe();
  }

  removeAlert(event, i): void {
    this.alertService.removeAlert(i);
  }

  ngOnDestroy() {
    if (this.routerEvents$) {
      this.routerEvents$.unsubscribe();
    }
    if (this.alerts$) {
      this.alerts$.unsubscribe();
    }
    if (this.profile$) {
      this.profile$.unsubscribe();
    }
  }
}
